module.exports = __webpack_public_path__ + "static/media/student-icon.edf7d8a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/student-icon.png
// module id = 296
// module chunks = 0